import React, { useState } from 'react';
import { Link } from 'react-scroll';
import CtaSection from '../ctaSection/ctaSection';
import { submitStaticForm } from '../../utils/formSubmit';
import { useLanguage } from '../../i18n/LanguageContext';
import logo from '../../images/logo-transparent.png';

const Footer = () => {
  const { t } = useLanguage();
  const formEndpoint = 'https://formsubmit.co/Emmanuel-Merida@outlook.com';
  const [status, setStatus] = useState({ type: '', message: '' });

  const submitHandler = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    setStatus({ type: 'sending', message: t.footer?.emailSending });
    try {
      await submitStaticForm(form);
      form.reset();
      setStatus({ type: 'success', message: t.footer?.emailSent });
    } catch {
      setStatus({ type: 'error', message: t.footer?.emailError });
    }
  };

  return (
    <footer className="wpo-site-footer" style={{ background: '#0d1117', borderTop: '1px solid #1e293b' }}>
      <CtaSection />
      <div className="upper-footer" style={{ padding: '60px 0', background: '#13151a' }}>
        <div className="container">
          <div className="row">
            <div className="col col-lg-4 col-md-6 col-12">
              <div className="widget about-widget">
                <div className="logo widget-title" style={{ marginBottom: '16px' }}>
                  <img src={logo} alt="EM" style={{ height: '56px', width: 'auto' }} />
                </div>
                <p style={{ color: '#475569', fontSize: '14px', lineHeight: 1.7 }}>{t.footer?.bio}</p>
                <div className="social-icons" style={{ marginTop: '20px' }}>
                  <ul style={{ listStyle: 'none', display: 'flex', gap: '12px', padding: 0, margin: 0 }}>
                    <li><a href="mailto:Emmanuel-Merida@outlook.com" style={{ color: '#475569' }}><i className="ti-email"></i></a></li>
                    <li><a href="https://www.linkedin.com/in/emmanuel-m%C3%A9rida-toledo-8920b929a/" target="_blank" rel="noreferrer" style={{ color: '#475569' }}><i className="ti-linkedin"></i></a></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col col-lg-2 col-md-6 col-12">
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3 style={{ color: '#94a3b8', fontSize: '13px', fontWeight: 700, letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '16px' }}>{t.footer?.navigation}</h3>
                </div>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  <li style={{ marginBottom: '8px' }}><Link to="service" spy smooth duration={500} style={{ color: '#475569', cursor: 'pointer' }}>{t.footer?.links?.services}</Link></li>
                  <li style={{ marginBottom: '8px' }}><Link to="work" spy smooth duration={500} style={{ color: '#475569', cursor: 'pointer' }}>{t.footer?.links?.work}</Link></li>
                  <li style={{ marginBottom: '8px' }}><Link to="results" spy smooth duration={500} style={{ color: '#475569', cursor: 'pointer' }}>{t.footer?.links?.results}</Link></li>
                  <li style={{ marginBottom: '8px' }}><Link to="contact" spy smooth duration={500} style={{ color: '#475569', cursor: 'pointer' }}>{t.footer?.links?.contact}</Link></li>
                </ul>
              </div>
            </div>
            <div className="col col-lg-3 col-md-6 col-12">
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3 style={{ color: '#94a3b8', fontSize: '13px', fontWeight: 700, letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '16px' }}>{t.footer?.allServices}</h3>
                </div>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {(t.footer?.services ?? []).map((service, idx) => (
                    <li key={idx} style={{ marginBottom: '8px' }}>
                      <Link to="service" spy smooth duration={500} style={{ color: '#475569', cursor: 'pointer' }}>{service}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col col-lg-3 col-md-6 col-12">
              <div className="widget newsletter-widget">
                <div className="widget-title">
                  <h3 style={{ color: '#94a3b8', fontSize: '13px', fontWeight: 700, letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '16px' }}>{t.footer?.contact}</h3>
                </div>
                <p style={{ color: '#475569', fontSize: '13px', lineHeight: 1.6, marginBottom: '16px' }}>{t.footer?.footerContactDesc}</p>
                <form action={formEndpoint} method="POST" onSubmit={submitHandler}>
                  <input type="hidden" name="_subject" value="New footer contact from emmanuelmerida.com" />
                  <input type="hidden" name="_template" value="table" />
                  <input type="hidden" name="_captcha" value="false" />
                  <div className="input-1" style={{ display: 'flex', gap: '8px' }}>
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder={t.form?.emailPlaceholder}
                      required
                      onChange={() => setStatus({ type: '', message: '' })}
                      style={{ background: '#0f172a', border: '1px solid #1e293b', color: '#f1f5f9', borderRadius: '6px', padding: '10px 14px', flex: 1 }}
                    />
                    <button
                      type="submit"
                      disabled={status.type === 'sending'}
                      style={{ background: 'linear-gradient(90deg, #06b6d4, #8b5cf6)', border: 'none', borderRadius: '6px', padding: '10px 14px', cursor: 'pointer', color: '#fff' }}
                    >
                      <i className="ti-email"></i>
                    </button>
                  </div>
                  {status.message && <p style={{ color: status.type === 'error' ? '#ef4444' : '#06b6d4', fontSize: '12px', marginTop: '8px' }}>{status.message}</p>}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="lower-footer" style={{ background: '#0d1117', borderTop: '1px solid #1e293b', padding: '20px 0' }}>
        <div className="container">
          <p className="copyright" style={{ color: '#475569', fontSize: '12px', textAlign: 'center', margin: 0 }}>{t.footer?.copyright}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
